import {
  Table,
  Button,
  Drawer,
  Form,
  Input,
  Select,
  Divider,
  message,
  Popconfirm,
  Space,
  Upload,
  Row,
  Col,
} from "antd";

import { useEffect, useState } from "react";
import api from "../../services/api";
import "../../css/product.css";
export default function Products() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [colors, setColors] = useState([]); // ✅ FIX
  const [attributes, setAttributes] = useState([]);
  const [open, setOpen] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [categoriesAll, setCategoriesAll] = useState([]);
  const [brandsAll, setBrandsAll] = useState([]);
  const [modelsAll, setModelsAll] = useState([]);
  const [colorsAll, setColorsAll] = useState([]);

  const [filters, setFilters] = useState({
    search: "",
    category_id: null,
    subcategory_id: null,
    brand_id: null,
    model_id: null,
    color_id: null,
  });

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 50,
    total: 0,
  });

  const [sorter, setSorter] = useState({
    field: "createdAt",
    order: "descend",
  });

  const [form] = Form.useForm();

  useEffect(() => {
    loadFilters();
  }, []);

  useEffect(() => {
    loadProducts();
  }, [filters, pagination.current, pagination.pageSize, sorter]);

  useEffect(() => {
    if (open) {
      loadMasterData();
    }
  }, [open]);

  /* ================= LOAD ================= */

  const loadFilters = async () => {
    const res = await api.get("/products/filters");
    setCategories(res.data.categories || []);
    setSubCategories(res.data.subcategories || []);
    setBrands(res.data.brands || []);
    setModels(res.data.models || []);
    setColors(res.data.colors || []);
  };

  const loadMasterData = async () => {
    try {
      const [catRes, brandRes, modelRes, colorRes] = await Promise.all([
        api.get("/categories"),
        api.get("/catalog/brands"),
        api.get("/catalog/models"),
        api.get("/attributes"), // 🔥 ADD THIS
      ]);

      setCategoriesAll(catRes.data || []);
      setBrandsAll(brandRes.data || []);
      setModelsAll(modelRes.data || []);
      console.log(colorRes.data[0]);
      setColorsAll(colorRes.data[0]?.AttributeValues || []);
    } catch (err) {
      console.error(err);
    }
  };

  const loadAttributes = async () => {
    const res = await api.get("/attributes");
    setAttributes(res.data || []);
  };

  const loadSubCategories = async (id) => {
    const res = await api.get(`/catalog/subcategories?category_id=${id}`);
    setSubCategories(res.data || []);
  };

  const loadModels = async (id) => {
    const res = await api.get(`/catalog/models?brand_id=${id}`);
    setModels(res.data || []);
  };

  const loadProducts = async (extra = {}) => {
    try {
      const params = Object.fromEntries(
        Object.entries({
          ...filters,
          ...extra,
          page: pagination.current,
          limit: pagination.pageSize,
          sortBy: sorter.field,
          sortOrder: sorter.order === "ascend" ? "ASC" : "DESC",
        }).filter(([_, v]) => v !== null && v !== ""),
      );

      const res = await api.get("/products", { params });

      setProducts(res.data.data || []);

      setPagination((prev) => ({
        ...prev,
        total: res.data.total || 0,
      }));
    } catch (err) {
      console.error(err);
      message.error("Failed to load products");
    }
  };

  /* ================= FILTER ================= */

  const handleFilterChange = (key, val) => {
    setFilters((prev) => ({
      ...prev,
      [key]: val,
    }));

    // 🔥 reset page to 1
    setPagination((prev) => ({
      ...prev,
      current: 1,
    }));
  };

  const resetFilters = () => {
    const reset = {
      search: "",
      category_id: null,
      subcategory_id: null,
      brand_id: null,
      model_id: null,
      color_id: null,
      model_ids: [],
    };
    setFilters(reset);
    loadProducts(reset);
  };

  /* ================= BULK ================= */

  const handleBulkDelete = async () => {
    if (!selectedRowKeys.length) {
      return message.warning("Select products first");
    }
    await api.post("/products/bulk-delete", {
      ids: selectedRowKeys,
    });

    message.success("Deleted");
    setSelectedRowKeys([]);
    loadProducts();
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: setSelectedRowKeys,
  };

  /* ================= FORM ================= */

  const handleSubmit = async (values) => {
    const formData = new FormData();

    Object.entries(values).forEach(([k, v]) => {
      if (v) formData.append(k, v);
    });

    formData.set("model_ids", JSON.stringify(values.model_ids || []));

    const attributesPayload = [];

    if (values.color_id) {
      attributesPayload.push({
        attribute_id: 17,
        attribute_value_id: values.color_id,
      });
    }

    formData.append("attributes", JSON.stringify(attributesPayload));

    let hasExisting = false;
    let hasNew = false;

    fileList.forEach((file) => {
      if (file.id) hasExisting = true;

      if (!file.id && file.originFileObj) {
        hasNew = true;
        formData.append("images", file.originFileObj);
      }
    });

    // 🔥 KEY FIXES
    if (!hasExisting && !hasNew) {
      formData.append("remove_all_images", "true");
    }

    if (hasNew) {
      formData.append("override_image", "true");
    }

    if (editingProduct) {
      await api.put(`/products/${editingProduct.id}`, formData);
      message.success("Updated");
    } else {
      await api.post("/products", formData);
      message.success("Created");
    }
    setEditingProduct(false);
    setOpen(false);
    form.resetFields();
    setFileList([]);
    loadProducts();
  };

  const handleEdit = (record) => {
    setEditingProduct(record);

    const colorAttr = record.attributes?.find(
      (a) => a.Attribute?.name?.toLowerCase() === "colors",
    );
    setFileList(
      record.images.map((img) => ({
        uid: `existing-${img.id}`,
        name: img.image_url.split("/").pop(),
        status: "done",
        url: `${process.env.REACT_APP_API_URL}${img.image_url}`,
        id: img.id,
      })),
    );

    form.setFieldsValue({
      name: record.name,
      description: record.description,
      category_id: record.category?.id,
      subcategory_id: record.subcategory?.id,
      brand_id: record.brand?.id,

      model_id: record.productModel?.id,

      model_ids: record.models?.map((m) => m.id) || [],

      color_id: colorAttr?.attribute_value_id,
      base_price: record.final_base_price,
      discount_price: record.final_discount_price,
    });

    if (record.brand?.id) {
      loadModels(record.brand.id);
    }
    setOpen(true);
  };

  /* ================= TABLE ================= */

  const columns = [
    { title: "Name", dataIndex: "name" },
    { title: "Category", render: (_, r) => r.category?.name || "-" },
    { title: "SubCategory", render: (_, r) => r.subcategory?.name || "-" },
    { title: "Brand", render: (_, r) => r.brand?.name || "-" },
    { title: "Model", render: (_, r) => r.productModel?.name || "-" },
    {
      title: "Compatible Models",
      key: "compatible_models",
      render: (_, record) =>
        record.models?.length
          ? record.models.map((m) => m.name).join(", ")
          : "-",
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text) => (
        <div
          style={{
            maxWidth: 200,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {text || "-"}
        </div>
      ),
    },
    {
      title: "Price",
      render: (_, r) => {
        const hasDiscount = Number(r.final_discount_price) > 0;
        return hasDiscount ? (
          <div className="price-wrapper">
            <div className="price-discount">£ {r.final_discount_price}</div>
            <div className="price-base">£ {r.final_base_price}</div>
          </div>
        ) : (
          <div className="price-normal">£ {r.final_base_price}</div>
        );
      },
    },
    {
      title: "Variant",
      render: (_, r) => {
        const colorAttr = r.attributes?.find(
          (a) => a.Attribute?.name?.toLowerCase() === "colors",
        );

        return colorAttr?.AttributeValue?.value || "-";
      },
    },
    {
      title: "Image",
      render: (_, r) => {
        const img = r.images?.[0]?.image_url;
        return img ? (
          <img src={`${process.env.REACT_APP_API_URL}${img}`} width={50} />
        ) : (
          "-"
        );
      },
    },

    {
      title: "Action",
      render: (_, r) => (
        <>
          <Button size="small" onClick={() => handleEdit(r)}>
            Edit
          </Button>

          <Popconfirm
            title="Delete?"
            onConfirm={() => api.delete(`/products/${r.id}`).then(loadProducts)}
          >
            <Button danger size="small" style={{ marginLeft: 8 }}>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  /* ================= UI ================= */

  return (
    <>
      {/* ACTION */}
      <Space style={{ marginBottom: 10 }}>
        <Button type="primary" onClick={() => setOpen(true)}>
          Add Product
        </Button>

        <Popconfirm
          title="Delete selected?"
          onConfirm={handleBulkDelete}
          disabled={!selectedRowKeys.length}
        >
          <Button danger disabled={!selectedRowKeys.length}>
            Delete Selected ({selectedRowKeys.length})
          </Button>
        </Popconfirm>
      </Space>

      {/* FILTERS */}
      <Row gutter={10} style={{ marginBottom: 15 }}>
        <Col>
          <Input
            placeholder="Search"
            onChange={(e) => handleFilterChange("search", e.target.value)}
          />
        </Col>

        <Col>
          <Select
            placeholder="Category"
            allowClear
            style={{ width: 150 }}
            value={filters.category_id || undefined} // 🔥 important
            options={categories.map((c) => ({
              value: c.id,
              label: c.name,
            }))}
            onChange={(val) => {
              handleFilterChange("category_id", val);
              handleFilterChange("subcategory_id", null);
            }}
          />
        </Col>

        <Col>
          <Select
            placeholder="SubCategory"
            allowClear
            style={{ width: 150 }}
            value={filters.subcategory_id} // ✅ ADD THIS
            disabled={!filters.category_id}
            options={subCategories.map((s) => ({
              value: s.id,
              label: s.name,
            }))}
            onChange={(val) => handleFilterChange("subcategory_id", val)}
          />
        </Col>

        <Col>
          <Select
            placeholder="Brand"
            allowClear
            style={{ width: 150 }}
            value={filters.brand_id} // ✅ ADD THIS
            options={brands.map((b) => ({
              value: b.id,
              label: b.name,
            }))}
            onChange={(val) => {
              handleFilterChange("brand_id", val);
              handleFilterChange("model_id", null);
              handleFilterChange("model_ids", []);
            }}
          />
        </Col>

        <Col>
          <Select
            placeholder="Model"
            allowClear
            style={{ width: 150 }}
            disabled={!filters.brand_id}
            options={models.map((m) => ({ value: m.id, label: m.name }))}
            onChange={(v) => handleFilterChange("model_id", v)}
          />
        </Col>

        <Col>
          <Select
            placeholder="Variant"
            allowClear
            style={{ width: 100 }}
            options={colors.map((c) => ({ value: c.id, label: c.value }))}
            onChange={(v) => handleFilterChange("color_id", v)}
          />
        </Col>

        <Col>
          <Button onClick={resetFilters}>Reset</Button>
        </Col>
      </Row>

      <Table
        columns={columns}
        dataSource={products}
        rowKey="id"
        rowSelection={rowSelection}
        pagination={pagination}
        onChange={(p, _, s) => {
          setPagination(p);
          setSorter(s);
          loadProducts({
            page: p.current,
            limit: p.pageSize,
            sortBy: s.field,
            sortOrder: s.order,
          });
        }}
      />

      <Drawer
        open={open}
        width={700}
        title={editingProduct ? "Edit Product" : "Add Product"}
        onClose={() => {
          setOpen(false);
          form.resetFields();
          setFileList([]);
          setEditingProduct(null);
        }}
      >
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <Form.Item name="name" label="Product Name">
            <Input disabled={!editingProduct} placeholder="Auto-generated" />
          </Form.Item>
          {/* CATEGORY */}
          <Form.Item
            name="category_id"
            label="Category"
            rules={[{ required: true }]}
          >
            <Select
              showSearch
              placeholder="Search category..."
              optionFilterProp="label"
              filterOption={(input, option) =>
                option?.label?.toLowerCase().includes(input.toLowerCase())
              }
              options={categoriesAll.map((c) => ({
                value: c.id,
                label: c.name,
              }))}
              onChange={(val) => {
                loadSubCategories(val); // optional API call
                form.setFieldsValue({ subcategory_id: null });
              }}
            />
          </Form.Item>

          {/* SUBCATEGORY */}
          <Form.Item
            name="subcategory_id"
            label="SubCategory"
            rules={[{ required: true }]}
          >
            <Select
              disabled={!form.getFieldValue("category_id")}
              options={subCategories.map((s) => ({
                value: s.id,
                label: s.name,
              }))}
            />
          </Form.Item>

          {/* BRAND */}
          <Form.Item name="brand_id" label="Brand" rules={[{ required: true }]}>
            <Select
              options={brandsAll.map((b) => ({ value: b.id, label: b.name }))}
              showSearch
              optionFilterProp="label"
              filterOption={(input, option) =>
                option?.label?.toLowerCase().includes(input.toLowerCase())
              }
              onChange={(val) => {
                loadModels(val); // optional API call
                form.setFieldsValue({ model_id: null });
              }}
            />
          </Form.Item>

          {/* MODEL */}
          <Form.Item name="model_id" label="Model" rules={[{ required: true }]}>
            <Select
              showSearch
              placeholder="Search category..."
              optionFilterProp="label"
              filterOption={(input, option) =>
                option?.label?.toLowerCase().includes(input.toLowerCase())
              }
              disabled={!form.getFieldValue("brand_id")}
              options={models.map((m) => ({ value: m.id, label: m.name }))}
            />
          </Form.Item>

          <Form.Item name="model_ids" label="Compatible Models">
            <Select
              mode="multiple"
              showSearch
              placeholder="Select Models"
              optionFilterProp="label"
              filterOption={(input, option) =>
                option?.label?.toLowerCase().includes(input.toLowerCase())
              }
              disabled={!form.getFieldValue("brand_id")}
              options={models.map((m) => ({
                value: m.id,
                label: m.name,
              }))}
            />
          </Form.Item>

          {/* DESCRIPTION */}
          <Form.Item name="description" label="Description">
            <Input.TextArea rows={3} placeholder="Enter description" />
          </Form.Item>

          {/* PRICE */}
          <Row gutter={10}>
            <Col span={12}>
              <Form.Item
                name="base_price"
                label="Base Price"
                rules={[{ required: true }]}
              >
                <Input type="number" />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item label="Discount Price">
                <Space.Compact style={{ width: "100%" }}>
                  <Form.Item name="discount_price" noStyle>
                    <Input type="number" style={{ width: "100%" }} />
                  </Form.Item>

                  <Button
                    onClick={() => {
                      form.setFieldsValue({ discount_price: "0" });
                    }}
                  >
                    Clear
                  </Button>
                </Space.Compact>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            name="color_id"
            label="Variant (Color)"
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Select Color"
              showSearch
              optionFilterProp="label"
              filterOption={(input, option) =>
                option?.label?.toLowerCase().includes(input.toLowerCase())
              }
              options={colorsAll.map((c) => ({
                value: c.id,
                label: c.value,
              }))}
            />
          </Form.Item>

          <Divider>Images</Divider>

          {/* UPLOAD */}
          <Upload
            fileList={fileList}
            onChange={({ fileList }) => setFileList(fileList)}
            beforeUpload={() => false}
            listType="picture-card"
            multiple
            maxCount={10}
            onRemove={async (file) => {
              if (file.id) {
                try {
                  await api.delete(`/upload/product-image/${file.id}`);
                  message.success("Image deleted");
                } catch {
                  message.error("Delete failed");
                  return false;
                }
              }
              return true;
            }}
          >
            + Upload
          </Upload>

          {/* ACTION */}
          <div style={{ marginTop: 20, textAlign: "right" }}>
            <Button onClick={() => setOpen(false)} style={{ marginRight: 10 }}>
              Cancel
            </Button>

            <Button type="primary" htmlType="submit">
              {editingProduct ? "Update" : "Create"}
            </Button>
          </div>
        </Form>
      </Drawer>
    </>
  );
}
